import {
  createAsyncThunk,
  createSlice,
  isAsyncThunkAction,
} from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { getCurrentCustomerInfoAPI } from "./customer.api";
import { ICustomerModel, ICustomerState } from "./customer.models";

export const fetchCustomer = createAsyncThunk(
  "customer/getCustomer",
  async (thunkAPI, { rejectWithValue }) => {
    try {
      return (await getCurrentCustomerInfoAPI()).data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message);
    }
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState: {
    currentCustomer: {} as ICustomerModel,
  } as ICustomerState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(isAsyncThunkAction(fetchCustomer), (state, action) => {
      if (action.meta.requestStatus === "fulfilled") {
        state.currentCustomer = action.payload as ICustomerModel;
      }
    });
  },
});
export const selectCurrentCustomer = (state: RootState) =>
  state.customer.currentCustomer;
